import { z } from 'zod'

export const Timestamp = z.string().datetime({ offset: true })
export type Timestamp = z.infer<typeof Timestamp>
